import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/operators';

/** Injectable clock so specs can pin "now" and drive ticks by hand. */
@Injectable({ providedIn: 'root' })
export class DashboardClock {
  now(): Date {
    return new Date();
  }

  /** Emits `now()` immediately and then every `intervalMs`. */
  tick$(intervalMs: number): Observable<Date> {
    return timer(0, intervalMs).pipe(map(() => this.now()));
  }
}
